import { Bot, Brain, Camera, ClipboardCheck, Clapperboard, Gauge, Lightbulb, type LucideIcon, MessageCircle, MessageSquare, MessagesSquare, PhoneCall, MonitorPlay, NotebookPen, Play, ShieldCheck, Target, Users, Video } from 'lucide-react';

/** Icons for the competitor comparison pages, keyed by the ids in src/data/alternatives.ts. */
export const COMPETITOR_ICONS: Record<string, LucideIcon> = {
  hirevue: Video,
  sparkhire: MessageSquare,
  testgorilla: ClipboardCheck,
  willo: Users,
  vervoe: Target,
  hireflix: Play,
  vidcruiter: MonitorPlay,
  paradox: MessageCircle,
  metaview: NotebookPen,
  brighthire: Lightbulb,
  talview: ShieldCheck,
  'interviewer-ai': Bot,
  myinterview: Camera,
  jobma: Clapperboard,
  harver: Gauge,
  'criteria-corp': Brain,
  'glider-ai': PhoneCall,
  sapia: MessagesSquare,
};
